import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ClientDashboardFiltersModel } from '../../Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel';

declare var IS_RUNNING_IN_APP_POOL;

export class DashboardFilterReorderClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(request: Array<ClientDashboardFiltersModel>): Promise<Array<ClientDashboardFiltersModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/DashboardFilterReorder/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.put<Array<ClientDashboardFiltersModel>, any>(url, data);
  }
}

